import Image from "next/image";
import Link from "next/link";
import { cn } from "@/lib/utils";

/**
 * Served from /public. These were hotlinked from the WordPress uploads
 * folder — the light one off databidmachine.ai, which now 404s, so the
 * light-mode mark was silently broken on every page. Self-hosting also
 * removes a hard dependency on the old site staying up after the cutover.
 */
export const LIGHT_LOGO = "/dbm-logo.png";

export const DARK_LOGO = "/dbm-logo-dark.png";

export const CORE_LOGO = "/dbm-logo-dark.png";

function BrandMarks() {
  return (
    <>
      <Image
        src={LIGHT_LOGO}
        alt=""
        width={206}
        height={212}
        sizes="64px"
        priority
        className="brand-logo-img brand-logo-light"
      />
      <Image
        src={DARK_LOGO}
        alt=""
        width={712}
        height={704}
        sizes="38px"
        aria-hidden="true"
        className="brand-logo-img brand-logo-dark"
      />
    </>
  );
}

export function Logo({
  className,
  hideName = false,
}: {
  className?: string;
  hideName?: boolean;
}) {
  return (
    <span className={cn("brand", className)}>
      <BrandMarks />
      {!hideName && <span className="brand-name">Data Bid Machine</span>}
    </span>
  );
}

export function BrandLink({ className }: { className?: string }) {
  return (
    <Link href="/" className={cn("brand", className)} aria-label="Data Bid Machine — home">
      <BrandMarks />
      <span className="brand-name">Data Bid Machine</span>
    </Link>
  );
}
